import React, { FC, ButtonHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../../../components/Button'

import { ReactComponent as FacebookIcon } from '../../../../assets/logos/fb-circle-icon.svg'
import { ReactComponent as TikTokIcon } from '../../../../assets/logos/tiktok-circle-icon.svg'

import useAvailablePlatforms from '../../../../pages/RightsSummary/DigitalRight/useAvailablePlatforms'

import { FACEBOOK_PLATFORM, TIKTOK_PLATFORM } from '../../../../constants/selectLists/platformList'

import { uploadButton } from './styles.css'

interface CombinedFacebookTikTokButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {}

const CombinedFacebookTikTokButton: FC<CombinedFacebookTikTokButtonProps> = props => {
  const { t } = useTranslation()
  const { [FACEBOOK_PLATFORM]: showFacebookForm, [TIKTOK_PLATFORM]: showTikTokForm } = useAvailablePlatforms()

  const buttonText = showFacebookForm && showTikTokForm ? t('Meta/TikTok') : showFacebookForm ? t('Meta') : t('TikTok')

  return (
    <Button className={uploadButton} {...props}>
      {showFacebookForm && <FacebookIcon />}
      {buttonText}
      {showTikTokForm && <TikTokIcon />}
    </Button>
  )
}

export default CombinedFacebookTikTokButton
